import { __assign, __read } from "tslib";
/**
 * @see https://github.com/NervJS/taro/blob/next/packages/taro-components/src/components/picker-view-column/picker-view-column.tsx
 */
import React, { useContext, useEffect, useLayoutEffect, useMemo, useRef, useState, } from "react";
import classNames from "classnames";
import { PickerViewContext } from "./PickerView";
import { noop } from "../../../_util/noop";
export var PickerViewColumn = React.forwardRef(function PickerViewColumn(_a, ref) {
    var className = _a.className, style = _a.style, children = _a.children;
    var _b = useContext(PickerViewContext), _c = _b.value, value = _c === void 0 ? 0 : _c, indicatorClass = _b.indicatorClass, _d = _b.indicatorStyle, indicatorStyle = _d === void 0 ? {} : _d, onPickStart = _b.onPickStart, onPickEnd = _b.onPickEnd, onChange = _b.onChange;
    var contentRef = useRef(null);
    var heightRef = useRef(0);
    var timerRef = useRef(null);
    var indicatorRef = useRef(null);
    var _e = __read(useState(34), 2), indicatorHeight = _e[0], setIndicatorHeight = _e[1];
    var indicatorTop = useMemo(function () { return 120 - indicatorHeight / 2; }, [
        indicatorHeight,
    ]);
    var insRef = useRef({});
    useLayoutEffect(function () {
        var relativeHeight = indicatorTop - indicatorHeight * value;
        updateHeight(relativeHeight);
    }, [value, indicatorHeight, indicatorTop]);
    useEffect(function () {
        if (indicatorRef.current) {
            setIndicatorHeight(indicatorRef.current.clientHeight);
        }
    }, []);
    var Velocity = useMemo(function () {
        var minInterval = 30;
        var maxInterval = 100;
        var vTime = +new Date();
        var vy = 0;
        var velocity = 0;
        var recorder = {
            record: function (y) {
                var now = +new Date();
                velocity = -(-y + vy) / (now - vTime);
                if (now - vTime >= minInterval) {
                    velocity = now - vTime <= maxInterval ? velocity : 0;
                    vy = y;
                    vTime = now;
                }
            },
            getVelocity: function (y) {
                if (y !== vy) {
                    recorder.record(y);
                }
                return velocity;
            },
        };
        return recorder;
    }, []);
    function updateHeight(height, time, cb) {
        if (time === void 0) { time = 0.3; }
        if (cb === void 0) { cb = noop; }
        if (time > 1) {
            // eslint-disable-next-line no-param-reassign
            time = 1;
        }
        if (heightRef.current !== height) {
            heightRef.current = height;
            var transformValue = "translate3d(0, " + height + "px, 0)";
            var transitionValue = "cubic-bezier(0,0,0.2,1.15) " + time + "s";
            if (contentRef.current) {
                contentRef.current.style.transform = transformValue;
                contentRef.current.style.webkitTransform = transformValue;
                contentRef.current.style.transition = transitionValue;
                contentRef.current.style.webkitTransition = transitionValue;
            }
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(function () {
                cb();
                if (contentRef.current) {
                    contentRef.current.style.transition = "";
                    contentRef.current.style.webkitTransition = "";
                }
            }, +time * 1000);
        }
        else {
            cb();
        }
    }
    function handleTouchStart(event) {
        // 记录第一次的点击位置
        insRef.current.startY = event.changedTouches[0].clientY;
        insRef.current.preY = event.changedTouches[0].clientY;
        insRef.current.hadMove = false;
        onPickStart(event);
    }
    function handleTouchMove(event) {
        var y = event.changedTouches[0].clientY;
        var deltaY = y - insRef.current.preY;
        insRef.current.preY = y;
        insRef.current.touchEnd = false;
        if (Math.abs(y - insRef.current.startY) > 10) {
            insRef.current.hadMove = true;
        }
        heightRef.current += deltaY;
        Velocity.record(heightRef.current);
        if (contentRef.current) {
            contentRef.current.style.transform = "translate3d(0, " + heightRef.current + "px, 0)";
            contentRef.current.style.webkitTransform = "translate3d(0, " + heightRef.current + "px, 0)";
        }
    }
    function handleTouchEnd(event) {
        var max = 0;
        var min = -indicatorHeight * (React.Children.count(children) - 1);
        var endY = event.changedTouches[0].clientY;
        insRef.current.touchEnd = true;
        var height;
        var time = 0.3;
        if (!insRef.current.hadMove) {
            /** 点击 */
            // 屏幕高度
            var windowHeight = window.innerHeight;
            // picker__mask 垂直方向距离屏幕顶部的高度
            var relativeY = windowHeight - (indicatorHeight * 7) / 2;
            height = heightRef.current - indicatorTop - (endY - relativeY);
        }
        else {
            /** 滚动 */
            height = heightRef.current;
            var velocity = Velocity.getVelocity(height) * 4;
            if (velocity) {
                height += velocity * 40;
                time = Math.abs(velocity) * 0.1;
            }
            height -= indicatorTop;
        }
        if (height > max)
            height = 0;
        if (height < min)
            height = min;
        var index = Math.abs(Math.round(height / indicatorHeight));
        var relativeHeight = indicatorTop - indicatorHeight * index;
        updateHeight(relativeHeight, time < 0.3 ? 0.3 : time, function () {
            onPickEnd(event);
            onChange(index, { event: event });
        });
    }
    return (React.createElement("div", { ref: ref, className: classNames("tea-core-picker__column", className), style: style, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd },
        React.createElement("div", { className: "tea-core-picker__mask", style: { backgroundSize: "100% " + indicatorTop + "px" } }),
        React.createElement("div", { className: classNames("tea-core-picker__indicator", indicatorClass), style: __assign(__assign({ height: indicatorHeight }, indicatorStyle), { top: indicatorTop }), ref: indicatorRef }),
        React.createElement("div", { className: "tea-core-picker__content", ref: contentRef }, children)));
});
//# sourceMappingURL=PickerViewColumn.js.map